import React from "react";
import "../../Styles/certified/voltech.css";

export default function Finzly() {
  return (
    <>
      <div className="vol-certified-details-section">
        <div className="vol-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="vol-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="vol-certified-details-left">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="vol-certified-badge"
            />
            <div className="vol-certified-company-names">
              <a href="https://www.voltechgroup.com/" target="_blank" rel="noopener noreferrer">
              <img
                src="/assets/voltech/vol.png"
                alt="Walkzero Logo"
                className="vol-certified-company-logo"
              />
            </a>
              <h1 className="vol-certified-full-name">
              Voltech HR Services Pvt. Ltd.
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="vol-certified-details-right">
            <img
              src="/assets/voltech/vol_5.jpg"
              alt="Finzly Office"
              className="vol-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="vol-certified-description">
          <h2>
            Why Voltech HR Services Pvt. Ltd. is an Outstanding Workplaces
          </h2>
          <p>
            Voltech HR Services (VHRS) is a proud part of Voltech Group, a globally recognized leader with a presence in over 40+ countries and 6000+ employees worldwide. As a key division of Voltech Group, VHRS is dedicated to connecting top talent with exceptional opportunities, ensuring business success through workforce excellence.


          </p>
          <p>
            At Voltech HR Services (VHRS), we specialize in HR solutions,including recruitment, background verification, staffing & payroll, event management and attestation services. Our expertise spans engineering, IT, manufacturing, healthcare, oil & gas, construction, banking, hospitality, retail, logistics and many more, providing tailored workforce solutions to leading organizations.
          </p>
          <p>
            Voltech HR Services is strategically expanding to deliver top-tier talent and complete HR solutions, empowering businesses worldwide.
          </p>
          
          
        </div>
        
        <div className="vol-certified-info-cards">
          <div className="vol-certified-info-card">
            <div className="vol-certified-info-title">COMPANY SIZE</div>
            <div className="icom-certified-info-value">100+ Employees</div>
          </div>
          <div className="vol-certified-info-card">
            <div className="vol-certified-info-title">INDUSTRY</div>
            <div className="vol-certified-info-value">HR Services

</div>
          </div>
          <div className="vol-certified-info-card">
            <div className="vol-certified-info-title">CONNECT</div>
            <div className="vol-certified-info-icons">
              <span className="vol-certified-icon-round">
                <a href="https://www.voltechgroup.com/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="vol-certified-icon-round">
                <a href="https://www.linkedin.com/company/voltechgroup/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="vol-certified-icon-round">
                <a href="https://www.facebook.com/voltechgroup" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
            </div>
          </div>
          <div className="vol-certified-info-card">
            <div className="vol-certified-info-title">LOCATION (HQ)</div>
            <div className="vol-certified-info-value">Chennai</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="vol-certified-recognition-section">
          <h2 className="vol-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="vol-certified-recognition-badge">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="vol-certified-recognition-image"
            />
          </div>
          <div className="vol-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at Finzly Section */}
        <div className="vol-certified-life-section">
          <h2 className="vol-certified-life-title">
            Life at   Voltech HR Services Pvt. Ltd.
          </h2>
          <div className="vol-certified-life-gallery">
            <div className="vol-certified-life-col">
              <img src="/assets/voltech/vol_1.jpg" alt="Office 1" className="vol-certified-life-img" />
              <img src="/assets/voltech/vol_3.jpg" alt="Team 1" className="vol-certified-life-img" />
            </div>
            <div className="vol-certified-life-col vol-certified-life-center">
              <img src="/assets/voltech/vol_2.jpg" alt="Main Office" className="vol-certified-life-img vol-certified-life-img-large" />
            </div>
            <div className="vol-certified-life-col">
              <img src="/assets/voltech/vol_6.jpg" alt="Office 2" className="vol-certified-life-img" />
              <img src="/assets/voltech/vol_4.jpg" alt="Team 2" className="vol-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
